"use client";

import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export default function QuoteDivider() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-10%" });

  return (
    <section ref={ref} className="relative py-16 md:py-24 overflow-hidden flex items-center justify-center">
      {/* BACKGROUND */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url('/bg.webp')",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
        }}
      />

      {/* BLUE OVERLAY */}
      <div
        className="absolute inset-0 z-0"
        style={{
          background: "linear-gradient(135deg, rgba(0,102,153,0.88) 0%, rgba(0,34,51,0.95) 100%)",
        }}
      />

      {/* CONTENT */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 sm:px-10 flex flex-col items-center gap-8 md:gap-10 text-center">
        
        {/* Quote */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="relative px-6 sm:px-10"
        >
          <span className="absolute -top-4 -left-0 md:-left-4 text-5xl md:text-6xl text-[#7dd3fc]/30 font-bold leading-none">"</span>
          <p className="text-white text-lg sm:text-xl md:text-2xl font-light tracking-wide leading-relaxed z-10 relative">
            As engineers, we were going to be in a position to change the world - not just study it.
          </p>
          <span className="absolute -bottom-6 -right-0 md:-right-4 text-5xl md:text-6xl text-[#7dd3fc]/30 font-bold leading-none rotate-180">"</span>
        </motion.div>

        {/* Divider line */}
        <motion.div 
          initial={{ width: 0 }}
          animate={isInView ? { width: "40px" } : {}}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="h-[2px] bg-[#7dd3fc]/50 mt-2"
        />

        {/* Author */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={isInView ? { opacity: 1, scale: 1 } : {}}
          transition={{ delay: 0.6, duration: 0.6 }}
          className="flex flex-col items-center gap-5 mt-2"
        >
          {/* Bigger circular photo */}
          <div className="w-32 h-32 md:w-44 md:h-44 lg:w-52 lg:h-52 rounded-full overflow-hidden border-[3px] border-[#7dd3fc] shadow-[0_0_25px_rgba(125,211,252,0.25)] flex-shrink-0">
            <img 
              src="/henry.jpeg" 
              alt="Henry Petroski" 
              className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500"
              onError={(e) => { e.target.src = '/asset/gallery/g1 (1).jpg'; e.target.onerror = null; }}
            />
          </div>
          <div className="text-center mt-2">
            <h4 className="text-white font-medium text-lg md:text-xl tracking-wider">Henry Petroski</h4>
            <p className="text-[#7dd3fc] text-xs md:text-sm uppercase tracking-widest mt-1.5">American Engineer</p>
          </div>
        </motion.div>

      </div>
    </section>
  );
}
